// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_rc-align@2.3.5@rc-align/es/index.js
// module id = 401
// module chunks = 0